import { atom, useAtomValue, useSetAtom } from 'jotai';
import { v4 as randomUuid } from 'uuid';
import { useMemo, useEffect } from 'react';

export const sessionIdAtom = atom<string>();

export const useSessionId = (): string => {
  const sessionId = useAtomValue(sessionIdAtom);
  const setSessionId = useSetAtom(sessionIdAtom);

  useEffect(() => {
    if (!sessionId) {
      const newSessionId = randomUuid();
      setSessionId(newSessionId);
    }
  }, [sessionId, setSessionId]);

  return useMemo(() => {
    return sessionId;
  }, [sessionId]);
};
